import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const LanguageSwitch = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => (i18n.language === "th" ? "en" : "th");

  const isActive = (code) => i18n.language === code;

  return (
    <div className="w-26 h-9 p-1 rounded-full bg-primary-dark text-primary-text-dark mb-4">
      <Link
        to="#"
        onClick={() => i18n.changeLanguage(toggleLanguage())}
        className="w-full h-full flex justify-center items-center gap-x-1 text-lg font-normal cursor-pointer before:w-2 before:h-2 before:rounded-full after:w-2 after:h-2 after:rounded-full before:bg-secondary-text-invert"
      >
          <div className="w-full h-full flex justify-center items-center gap-x-1 text-lg font-normal cursor-pointer">
            <span
              className={isActive("th") ? "text-secondary-text-invert" : ""}
            >
              ไทย
            </span>
            <span className="font-thin">|</span>
            <span
              className={isActive("en") ? "text-secondary-text-invert" : ""}
            >
              EN
            </span>
          </div>
      </Link>
    </div>
  );
};

export default LanguageSwitch;
